module.exports = __webpack_public_path__ + "img/cls-shooting-brake.a8852d3e.jpg";